module.exports = __webpack_public_path__ + "static/media/Inter-italic.var.f86d3fe2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-italic.var.woff2
// module id = 711
// module chunks = 21